import { useState } from "react";
import { useParams } from "react-router-dom";
import useGetCloudApps from "../../../../api/api-hooks/cloudApps/useGetCloudApps";
import AppPageHeader from "../../../../components/Headers/AppPageHeader";
import { Container } from "reactstrap";
import AppEmptyState from "../../../../elements/AppEmptyState";
import useCloud from "../../../../api/api-hooks/cloud/useCloud";
import SettingsGroupCard from "../../../../elements/SettingsGroupCard";
import AppDrawer from "../../../../components/Drawers/AppDrawer";
import CloudList from "../../../cloud/CloudList";
import { AppConfirm } from "../../../../utils/PopupUtil";
import useCopyCloudApp from "../../../../api/api-hooks/cloudApps/useCopyCloudApp";

export default function ManageCloudApp() {
  const { cloudID, cloudAppID }: any = useParams();
  const { cloudApps, loadingApps } = useGetCloudApps(cloudID);

  const { cloud, cloudLoading } = useCloud(cloudID);
  const [selectCloudDrawer, setSelectCloudDrawer] = useState(false);

  if (loadingApps || cloudLoading) return null;

  const cloudApp = (cloudApps || []).find((app) => app.id === cloudAppID);

  if (!cloudApp) {
    return (
      <Container fluid className="mt-3">
        <AppEmptyState
          title="Cloud App Not Found"
          description="We couldn't find a cloud app with that ID."
        />
      </Container>
    );
  }

  return (
    <>
      <Container fluid>
        <AppPageHeader
          title={"Manage Cloud App"}
          description={
            <>
              Managing the cloud app{" "}
              <span className="text-primary font-weight-500">
                {cloudApp.Name || cloudApp.Title}
              </span>{" "}
              from the cloud{" "}
              <span className="text-primary font-weight-500">
                {cloud?.Name}
              </span>
            </>
          }
        />
        <SettingsGroupCard
          onClick={() => setSelectCloudDrawer(true)}
          title="Copy Cloud App To Another Cloud"
          description="Fully copies over an app to another cloud. Passes along all schemas, and documents used in the app."
        />
      </Container>
      <SelectCloudDrawer
        open={selectCloudDrawer}
        onClose={() => setSelectCloudDrawer(false)}
        cloudID={cloudID}
        cloudAppID={cloudAppID}
      />
    </>
  );
}

function SelectCloudDrawer(props: {
  open: boolean;
  cloudID: string;
  cloudAppID: string;
  onClose: () => void;
}) {
  const { open, cloudID, cloudAppID, onClose } = props;
  const { copyCloudApp } = useCopyCloudApp();

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      headerTitle="Select Cloud To Copy App To"
      body={
        <CloudList
          isDrawer={true}
          closeDrawer={onClose}
          customOnClick={handleCopyCloudApp}
          cloudsToHide={[cloudID]}
          favoritesEnabled={false}
        />
      }
    />
  );

  async function handleCopyCloudApp(toCloud: {
    TenantName: string;
    TenantID: string;
  }) {
    onClose();

    const result = await AppConfirm({
      title: `Copy app to ${toCloud?.TenantName ?? "cloud"}?`,
      text: `All associated app data will be installed to ${toCloud?.TenantName}. This includes page, views, and module schemas, as well as any document records used in the app.`,
      confirmButtonColor: "var(--primary)",
      confirmButtonText: "Confirm",
    });

    if (!result.isConfirmed) return;

    copyCloudApp({
      fromCloudID: cloudID,
      toCloudID: toCloud?.TenantID,
      cloudAppID,
    });
  }
}
